import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'shared/hooks/useSafeTranslation'

import useStyle from 'shared/hooks/useStyle'
import Dialog from 'shared/Dialog'
import ManualInput from 'shared/ManualInput'
import styles from './ManualAssetNumber.style'

const propTypes = { onChange: PropTypes.func.isRequired }

const ManualAssetNumber = ({ onChange }) => {
    const { t } = useTranslation()
    const classes = useStyle(styles)

    const titleMessage = t('PLEASE_ENTER_CODE_OF_CONTAINER_IN_FRONT_OF_YOU')

    return (
        <Dialog
            titleMessage={titleMessage}
            customClasses={{ dialogContentRoot: classes.dialogContentRoot }}
        >
            <ManualInput
                customClasses={{
                    contextContainer: classes.contextContainer,
                    button: classes.contextButton,
                }}
                onChange={onChange}
            />
        </Dialog>
    )
}

ManualAssetNumber.propTypes = propTypes

export default ManualAssetNumber
